import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';

class MilestoneAnimation {
	constructor(selector = '.milestone-shortcode') {
		this.selector = selector;
		this.draggables = [];
		gsap.registerPlugin(Draggable);
	}

	init() {
		this.tracks = document.querySelectorAll(this.selector);

		this.tracks.forEach((track) => this.createDraggable(track));
	}

	createDraggable(track) {
		const viewport = this.createViewport(track);

		if (!viewport || track.scrollWidth <= viewport.clientWidth) {
			return;
		}

		const maxDragDistance = track.scrollWidth - viewport.clientWidth;
		const [draggable] = Draggable.create(track, {
			type: 'x',
			bounds: {
				minX: -maxDragDistance,
				maxX: 0,
			},
			cursor: 'grab',
			activeCursor: 'grabbing',
			onPress: () => viewport.classList.add('is-dragging'),
			onRelease: () => viewport.classList.remove('is-dragging'),
		});

		this.draggables.push(draggable);
	}

	createViewport(track) {
		const parent = track.parentElement;

		if (!parent) {
			return null;
		}

		if (parent.classList.contains('milestone-shortcode__viewport')) {
			return parent;
		}

		const viewport = document.createElement('div');
		viewport.className = 'milestone-shortcode__viewport';
		parent.insertBefore(viewport, track);
		viewport.appendChild(track);

		return viewport;
	}
}

export default new MilestoneAnimation();
